/**
 * Reliability Badge Component
 * Small badge to show guest reliability tier
 */
import React from 'react';
import { Badge } from '../ui/badge';
import { Trophy, Star, Award } from 'lucide-react';

const TIER_CONFIG = {
  Excellent: {
    bg: 'bg-amber-500/10',
    text: 'text-amber-600',
    border: 'border-amber-500/20',
    icon: Trophy
  },
  Good: {
    bg: 'bg-emerald-500/10',
    text: 'text-emerald-600',
    border: 'border-emerald-500/20',
    icon: Star
  },
  Standard: {
    bg: 'bg-slate-500/10',
    text: 'text-slate-600',
    border: 'border-slate-500/20',
    icon: Award
  }
};

export const ReliabilityBadge = ({ tier, size = 'sm' }) => {
  if (!tier || tier === 'Standard') return null; // Don't show badge for standard tier
  
  const config = TIER_CONFIG[tier] || TIER_CONFIG.Standard;
  const Icon = config.icon;
  
  return (
    <Badge 
      variant="secondary" 
      className={`${config.bg} ${config.text} ${config.border} ${size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-xs'}`}
      data-testid={`reliability-badge-${tier.toLowerCase()}`}
    >
      <Icon className={`${size === 'xs' ? 'w-2.5 h-2.5' : 'w-3 h-3'} mr-0.5`} />
      {tier}
    </Badge>
  );
};
